import { borrowSubtractionExplanation, createNaturalArithmeticTask, randInt } from "./sharedNaturalArithmetic";

function pickData() {
  for (let i = 0; i < 500; i += 1) {
    const a = randInt(31, 98);
    const b = randInt(12, Math.min(79, a - 1));
    if (a % 10 < b % 10) return { a, b, op: "-", result: a - b };
  }
  return { a: 52, b: 27, op: "-", result: 25 };
}

const mod = createNaturalArithmeticTask({
  type: "NaturalSubTwoDigitBorrowTask",
  pickData,
  explain: borrowSubtractionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
